import React, { useState } from 'react';
import styles from '../styles/comp2test.module.css';
import { useNavigate } from 'react-router-dom';

const RouteChefAd2 = () => {
const navigate=useNavigate();
const [inputValue, setInputValue] = useState("");

const handleInputKeyDown = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    navigate('/chat', { state: { fromHero: true, heroInput: inputValue } });
  }
};

  return (
    <div className={styles['routechef-container']}>
      <div className={styles['text-section']}>
        <h1 className={styles.heading}>Plan with Routechef AI</h1>
        <p className={styles.subheading}>
          Chat with AI for instant route suggestions, PNR status. Get tailored route plans from AI assistant and WhatsApp bot.
        </p>

        <div className={styles['button-container']}>
          <div className={styles['search-bar']}>
            <div className={styles['search-input']}>
              <img src="/Star1.svg" alt="Chat Icon" />
              <input
                type="text"
                placeholder="Chat with AI"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onKeyDown={handleInputKeyDown}
              />
            </div>
          </div>

          <button
            className={styles['chat-bot-button']}
            onClick={() => { window.open('https://wa.me/+919370622163', '_blank'); }}
          >
            <img src="/whatsappicon.svg" alt="WhatsApp Icon" className={styles['whatsapp-icon']} />
            Chat with Bot
          </button>
        </div>
      </div>

      <div className={styles['image-section']}>
        <video
          className={styles.comp1_imgstyle}
          src="/RCGIF.mp4"
          crossOrigin="anonymous" 
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    </div>
  );
};

export default RouteChefAd2;